import React, { useEffect } from "react";

// A card that sits in the page on Overview and, on every other tab, folds into a round button at the bottom right
// (above the WhatsApp help button). The button opens the card over the page; — or Escape folds it back.
// slot: 1 or 2, the button's place in the stack. open / onToggle: kept by the panel, so only one card opens at a time.
export default function FloatingPanel({ floating, open, onToggle, slot = 1, tone = "", icon, label, badge, children }) {
  useEffect(() => {
    if (!floating || !open) return undefined;
    const onKey = (e) => { if (e.key === "Escape") onToggle(false); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [floating, open, onToggle]);

  if (!floating) return children;
  return (
    <>
      <button type="button" className={`float-fab float-slot-${slot} ${tone} ${open ? "is-open" : ""}`} onClick={() => onToggle(!open)} aria-expanded={open} aria-label={open ? `Collapse ${label}` : `Open ${label}`} title={label}>
        <span aria-hidden="true">{open ? "✕" : icon}</span>
        {badge && !open && <em className="float-fab-badge">{badge}</em>}
      </button>
      {open && (
        <div className={`float-panel float-slot-${slot}`} role="dialog" aria-label={label}>
          <div className="float-panel-head">
            <b>{label}</b>
            <button type="button" onClick={() => onToggle(false)} aria-label={`Collapse ${label}`} title="Collapse">—</button>
          </div>
          <div className="float-panel-body">{children}</div>
        </div>
      )}
    </>
  );
}
